import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { EditorialRatingsEntities } from 'client/data/models/editorial-review';
import { getStaticImageUrl } from 'client/utils/image-helpers';

import './core-scorecard.scss';

function formatRating(rating, scale) {
  return rating && `${rating} / ${scale}`;
}

function hasRatings(ratings) {
  const keys = [];
  Object.entries(ratings).forEach(([key, val]) => {
    if (val && val.rating && val.rating.toString().length) {
      keys.push(key);
    }
  });
  return keys.length > 0;
}

export function CoreScorecard({ ratings, scale, className }) {
  const logoSrc = getStaticImageUrl('/images/logos/edmunds-logo-and-text-226x36-trans.png');

  return (
    hasRatings(ratings) && (
      <div className={classnames('scorecard mx-auto pb-0_5', className)}>
        <h3 className="heading-4 fw-normal ps-0_75 bg-gray-extra-light py-1 mb-0 scorecard-header">
          <img src={logoSrc} className="edmunds-image pe-0_5" alt="Edmunds" height={24} loading="lazy" />
          <span className="ps-0_5 text-primary-darker">Scorecard</span>
        </h3>
        <div className="px-0_75">
          <table className="w-100" cellPadding={0} cellSpacing={0}>
            <thead className="fw-bold">
              {ratings.overall && (
                <tr>
                  <td className="py-0_5">Overall</td>
                  <td className="py-0_5 text-end">{formatRating(ratings.overall.rating, scale)}</td>
                </tr>
              )}
            </thead>
            {ratings.driving && ratings.driving.rating && (
              <Fragment>
                <tbody>
                  <tr>
                    <td className="py-0_5">Driving</td>
                    <td className="py-0_5 text-end">{ratings.driving.rating}</td>
                  </tr>
                </tbody>
              </Fragment>
            )}

            {ratings.comfort && ratings.comfort.rating && (
              <Fragment>
                <tbody>
                  <tr>
                    <td className="py-0_5">Comfort</td>
                    <td className="py-0_5 text-end">{ratings.comfort.rating}</td>
                  </tr>
                </tbody>
              </Fragment>
            )}
            {ratings.interior && ratings.interior.rating && (
              <Fragment>
                <tbody>
                  <tr>
                    <td className="py-0_5">Interior</td>
                    <td className="py-0_5 text-end">{ratings.interior.rating}</td>
                  </tr>
                </tbody>
              </Fragment>
            )}
            {ratings.utility && ratings.utility.rating && (
              <Fragment>
                <tbody>
                  <tr>
                    <td className="py-0_5">Utility</td>
                    <td className="py-0_5 text-end">{ratings.utility.rating}</td>
                  </tr>
                </tbody>
              </Fragment>
            )}
            {ratings.technology && ratings.technology.rating && (
              <Fragment>
                <tbody>
                  <tr>
                    <td className="py-0_5">Technology</td>
                    <td className="py-0_5 text-end">{ratings.technology.rating}</td>
                  </tr>
                </tbody>
              </Fragment>
            )}
          </table>
        </div>
      </div>
    )
  );
}

CoreScorecard.propTypes = {
  ratings: EditorialRatingsEntities.isRequired,
  scale: PropTypes.number,
  className: PropTypes.string,
};

CoreScorecard.defaultProps = {
  scale: 5,
  className: null,
};
